import React, { useState, useEffect } from "react";
// import track, { useTracking } from "react-tracking";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useBeforeFirstRender } from "../../hooks/customHooks";
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  fireActionTriggerCustomEvent,
} from "../../utils/adobe-launch";
import {
  pageNameConverter,
  handleUpdatePageInfoData,
  handleEventInfoData,
  storeConverter,
} from "../../utils/storeConverter";

import { stores, getStore } from "../../data/Stores";
import { avatarMotion, textMotion } from "../../data/MotionVars";

import leftArrow from "../../assets/buttons/courtney-map-icon-arrow-left-dark.png";
import downArrow from "../../assets/buttons/courtney-icon-arrow-down-dark.png";
import upArrow from "../../assets/buttons/courtney-icon-arrow-up-dark.png";

import "./AvatarText.css";

function AvatarText({ location, match, changeStoreNum, tracking }) {
  let Store = getStore(match.params.id);
  let storeNum = parseInt(Store.id);
  let nextStore = storeNum > 1 ? storeNum - 1 : stores.length;
  let prevStore = storeNum < stores.length ? storeNum + 1 : 1;

  const splitPath = location.pathname.split("/");
  const page_name = pageNameConverter(splitPath);

  useBeforeFirstRender(() => {
    handleUpdatePageInfoData({
      page_name: page_name,
      page_title: "courtney: orange valley mall",
      game_name: "courtney",
      site_country: "us",
      site_language: "en",
    });
    fireViewStartCustomEvent(window.digitalData);
  });

  useEffect(() => {
    fireViewEndCustomEvent();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isTextMinimized, setIsTextMinimized] = useState(false);

  const handleText = () => {
    setIsTextMinimized((prevState) => !isTextMinimized);
  };


  const { title, id, videos, books, quiz, copy, game } = Store;

  const arrowDownButton = (
    <div
      className="downArrowContainer"
      onClick={(e) => {
        handleText();
        handleEventInfoData({
          storeName: storeConverter(splitPath[splitPath.length - 1]),
          page_name: window.digitalData.pageInfo.page_name + ":minimize tour",
          location_name: `courtney tour`,
        });
        fireActionTriggerCustomEvent(e.target, window.digitalData.event);
      }}
    >
      <img
        className="downArrow"
        src={downArrow}
        alt="minimize text area button"
      />
    </div>
  );

  const arrowUpButton = (
    <div
      className="upArrowContainer"
      onClick={(e) => {
        handleText();
        handleEventInfoData({
          storeName: storeConverter(splitPath[splitPath.length - 1]),
          page_name: window.digitalData.pageInfo.page_name + ":maximize tour",
          location_name: `courtney tour`,
        });
        fireActionTriggerCustomEvent(e.target, window.digitalData.event);
      }}
    >
      <img className="upArrow" src={upArrow} alt="maximize text area button" />
    </div>
  );

  const textMinimized = (
    <motion.section {...avatarMotion} className="avatarMinimizedText">
      <motion.div {...textMotion} className="textHolderMinimized">
        {isTextMinimized ? arrowUpButton : arrowDownButton}
        <div className="title">
          <p id="areaTitleText">
            <img
              className="titleIconImage"
              alt={`${Store.title} icon`}
              src={Store.images.darkIcon}
            />
            {title}
          </p>
        </div>

        <div className="nextPrev">
          <Link
            className="next"
            onClick={(e) => {
              changeStoreNum(prevStore);
              handleEventInfoData({
                storeName: storeConverter(splitPath[splitPath.length - 1]),
                page_name: window.digitalData.pageInfo.page_name + ":next",
                location_name: `courtney tour`,
              });
              fireActionTriggerCustomEvent(e.target, window.digitalData.event);
            }}
            to={`/store/${prevStore}`}
          >
            <img src={leftArrow} alt="next store link" />
          </Link>
          <Link
            className="prev"
            onClick={(e) => {
              changeStoreNum(nextStore);
              handleEventInfoData({
                storeName: storeConverter(splitPath[splitPath.length - 1]),
                page_name: window.digitalData.pageInfo.page_name + ":prev",
                location_name: `courtney tour`,
              });
              fireActionTriggerCustomEvent(e.target, window.digitalData.event);
            }}
            to={`/store/${nextStore}`}
          >
            <img src={leftArrow} alt="previous store link" />
          </Link>
        </div>
      </motion.div>
    </motion.section>
  );

  const textMaximized = (
    <motion.section {...avatarMotion} className="avatarText">
      <img
        className="courtneyAvatar"
        src="/american-girl/courtney-mall-game/static/media/Courtney.png"
        alt="Courtney"
      />

      <motion.div {...textMotion} className="textHolderMaximized">
        <div className="title">
          <p id="areaTitleText">
            <img
              className="titleIconImage"
              alt={`${Store.title} icon`}
              src={Store.images.darkIcon}
            />
            {title}
          </p>
        </div>

        {isTextMinimized ? arrowUpButton : arrowDownButton}

        <div className="copy">
          {copy.map((t, i) => (
            <p key={`p${i}`}>{t}</p>
          ))}
        </div>

        <div className="actionHolder">
          {game && !(title === "Smiley's Arcade") && (
            <Link
              onClick={(e) => {
                handleEventInfoData({
                  storeName: window.digitalData.pageInfo.page_name,
                  page_name:
                    window.digitalData.pageInfo.page_name +
                    `:${e.target.innerText}`,
                  location_name: `Courtney tour`,
                });
                fireActionTriggerCustomEvent(
                  e.target,
                  window.digitalData.event
                );
              }}
              to={`/store/${id}/game/`}
            >
              Play Games
            </Link>
          )}
          {videos && (
            <Link
              onClick={(e) => {
                handleEventInfoData({
                  storeName: window.digitalData.pageInfo.page_name,
                  page_name:
                    window.digitalData.pageInfo.page_name +
                    `:${e.target.innerText}`,
                  location_name: `Courtney tour`,
                });
                fireActionTriggerCustomEvent(
                  e.target,
                  window.digitalData.event
                );
              }}
              to={`/store/${id}/video/`}
            >
              Watch Videos
            </Link>
          )}
          {books && (
            <Link
              onClick={(e) => {
                handleEventInfoData({
                  storeName: window.digitalData.pageInfo.page_name,
                  page_name:
                    window.digitalData.pageInfo.page_name +
                    `:${e.target.innerText}`,
                  location_name: `Courtney tour`,
                });
                fireActionTriggerCustomEvent(
                  e.target,
                  window.digitalData.event
                );
              }}
              to={`/store/${id}/book/`}
            >
              Read Books
            </Link>
          )}
          {quiz && (
            <Link
              onClick={(e) => {
                handleEventInfoData({
                  storeName: window.digitalData.pageInfo.page_name,
                  page_name:
                    window.digitalData.pageInfo.page_name +
                    `:${e.target.innerText}`,
                  location_name: `Courtney tour`,
                });
                fireActionTriggerCustomEvent(
                  e.target,
                  window.digitalData.event
                );
              }}
              to={`/store/${id}/quiz/`}
            >
              Take Quiz
            </Link>
          )}
        </div>

        <div className="nextPrev">
          <Link
            className="next"
            onClick={(e) => {
              changeStoreNum(prevStore);
              handleEventInfoData({
                storeName: storeConverter(splitPath[splitPath.length - 1]),
                page_name: window.digitalData.pageInfo.page_name + ":next",
                location_name: `courtney tour`,
              });
              fireActionTriggerCustomEvent(e.target, window.digitalData.event);
            }}
            to={`/store/${prevStore}`}
          >
            <img src={leftArrow} alt="next store link" />
          </Link>
          <Link
            className="prev"
            onClick={(e) => {
              changeStoreNum(nextStore);
              handleEventInfoData({
                storeName: storeConverter(splitPath[splitPath.length - 1]),
                page_name: window.digitalData.pageInfo.page_name + ":prev",
                location_name: `courtney tour`,
              });
              fireActionTriggerCustomEvent(e.target, window.digitalData.event);
            }}
            to={`/store/${nextStore}`}
          >
            <img src={leftArrow} alt="previous store link" />
          </Link>
        </div>
      </motion.div>
    </motion.section>
  );

  return <div>{isTextMinimized ? textMinimized : textMaximized}</div>;
}

export default AvatarText;
